export default "__VITE_ASSET__DkCfC3eA__"